// Register Actions
export const Register_User_Details = "Register_User_Details";
export const Register_Company_Details = "Register_Company_Details";
export const Register_Company_Logo = "Register_Company_Logo";
export const Register_Progress = "Register_Progress";
export const Register_Current_Step = "Register_Current_Step";

// Auth Actions
export const Auth_Login = "Auth_Login";
export const Auth_Logout = "Auth_Logout";